// lib/access/footfallAccess.ts
import type { UserContext } from '#types/types';
import { canAccessSource } from '#lib/access/sourceAccess';
import { canAccessAnalyst } from '#lib/access/analystAccess';

/** Footfall serves the existing Source pilot and asset-management accounts. */
export function canAccessFootfall(user: Pick<UserContext, 'dbUserId' | 'permissions' | 'isFaterAdmin' | 'isFaterOrgMember'> | null | undefined): boolean {
  return canAccessSource(user) || canAccessAnalyst(user);
}
